import React from 'react';
import {CalendarIntakeBookProvider} from '../contexts/CalendarIntakeBookProvider'
import MonthlyIntakeBookContainer from '../containers/MonthlyIntakeBookContainer';


function MonthlyIntakeBook(props) {
    return (
        <div className="sidebar-bottomcontent-container">
            <div className="sidebar-bottomcontent-container-row">
                <CalendarIntakeBookProvider onLogoutClick={props.onLogoutClick}
                    setSelectedNavItem={props.setSelectedNavItem} isLogout={props.isLogout}
                    setLogoutFalse={props.setLogoutFalse} clearSessionData={props.clearSessionData}>
                        <MonthlyIntakeBookContainer BusinessPartnerCode={props.BusinessPartnerCode} 
                                                    isLogout={props.isLogout}   
                                                    onLogoutClick={props.onLogoutClick}
                                                    clearSessionData={props.clearSessionData} 
                                                    UserId ={props.UserId} />
                </CalendarIntakeBookProvider> 
            </div>
        </div>
    );
}

export default MonthlyIntakeBook;